import {baseUrlFunctionSwitch} from './urls'

export const FunctionSwitchResourceName = 'Function Switch';
export const FunctionSwitchHotSlaveResourceName = 'Whitelist - Hot Slave';
export const FunctionSwitchFoodyIntegrationResourceName = 'Whitelist - Foody integration';
export const FunctionSwitchAutoAcceptDeliveryOrdersResourceName = 'Whitelist - Auto accept delivery orders';
export const FunctionSwitchAssembledOrderLoadingInReportResourceName = 'Whitelist - Assembled Order Loading in Report';
export const FunctionSwitchNewMenuServiceResourceName = 'Whitelist - New Menu Service';

export const PremiumShopResourceName = 'Premium Shop';

export const ExtendMembershipResourceName = 'Extend Membership';

export const NowOchaShopResourceName = 'Now x Ocha shops';

export const ReminderConfigResourceName = 'Update Reminder Config';

export const DualScreenAdResourceName = '2nd Screen Ad';

export const localStoreKeyForShopDataPrepareRemove = 'function_switch_shop_data_need_remove';
export const localStoreKeyForShopDataPrepareEdit = 'function_switch_shop_data_need_edit';
export const localStoreKeyForCurrentFeatureName = 'function_switch_current_feature';

export const HOST_SLAVE_FEATURE_ID = 1;
export const FOODY_INTEGRATION_FEATURE_ID = 2;
export const AUTO_ACCEPT_FOODY_ORDERS_FEATURE_ID = 3;
export const E_PAYMENT_FEATURE_ID = 4;
export const ASSEMBLED_ORDER_LOADING_IN_REPORT_FEATURE_ID = 5;
export const NEW_MENU_SERVICE_ID = 6;
export const SHOP_ID_IN_WHITELIST = '1';
export const SHOP_ID_NOT_IN_WHITELIST = '0';

export const SHOP_IS_ENABLED_A_FUNCTION = [
  { id: 1, name: "Yes"},
  { id: 0, name: "No" }
];

export const SHOP_TYPE_NA	= 0;
export const SHOP_TYPE_PRIMARY =1;
export const SHOP_TYPE_BRANCH = 2;

export const FOODY_MENU_OBJECT_LIST = [
  { id: 1, name: "Dish type" },
  { id: 2, name: "Dish" },
  { id: 3, name: "Topping group" },
  { id: 4, name: "Topping" },
  { id: 5, name: "Topping mapping" },
];

export const MAPPING_REQUEST_STATUS_NA = 0;
export const MAPPING_REQUEST_STATUS_PENDING = 1;
export const MAPPING_REQUEST_STATUS_PROCESSING	= 2;
export const MAPPING_REQUEST_STATUS_APPROVED = 3;
export const MAPPING_REQUEST_STATUS_DENIED = 4;
export const MAPPING_REQUEST_STATUS_UNLINKED_FOODY = 5;
export const MAPPING_REQUEST_STATUS_UNLINKED_IIS = 6;
export const MAPPING_REQUEST_STATUS_UNLINKED = 7;
export const MAPPING_REQUEST_STATUS_MAPPED_IIS = 8;

export const MAPPING_REQUEST_STATUS_TEXT = {
  NO_REQUEST: 'NO REQUEST',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  APPROVED: 'APPROVED',
  FOODY_DENIED: 'FOODY DENIED',
  FOODY_UNLINKED: 'FOODY UNLINKED',
  IIS_UNLINKED: 'IIS UNLINKED',
  UNLINKED: 'UNLINKED',
  MAPPED_IIS: 'MAPPED_IIS',
};

export const MAPPING_REQUEST_STATUS_CODE_NAME = {
  [MAPPING_REQUEST_STATUS_NA]: MAPPING_REQUEST_STATUS_TEXT.NO_REQUEST,
  [MAPPING_REQUEST_STATUS_PENDING]: MAPPING_REQUEST_STATUS_TEXT.PENDING,
  [MAPPING_REQUEST_STATUS_PROCESSING]: MAPPING_REQUEST_STATUS_TEXT.PROCESSING,
  [MAPPING_REQUEST_STATUS_APPROVED]: MAPPING_REQUEST_STATUS_TEXT.APPROVED,
  [MAPPING_REQUEST_STATUS_DENIED]: MAPPING_REQUEST_STATUS_TEXT.FOODY_DENIED,
  [MAPPING_REQUEST_STATUS_UNLINKED_FOODY]: MAPPING_REQUEST_STATUS_TEXT.FOODY_UNLINKED,
  [MAPPING_REQUEST_STATUS_UNLINKED_IIS]: MAPPING_REQUEST_STATUS_TEXT.IIS_UNLINKED,
  [MAPPING_REQUEST_STATUS_UNLINKED]: MAPPING_REQUEST_STATUS_TEXT.UNLINKED,
  [MAPPING_REQUEST_STATUS_MAPPED_IIS]: MAPPING_REQUEST_STATUS_TEXT.MAPPED_IIS,
};

export const DELIVERY_STATUS_ACTIVE = true;
export const DELIVERY_STATUS_INACTIVE = false;

export const DELIVERY_STATUS_NAME = {
  [DELIVERY_STATUS_ACTIVE]: 'ACTIVE',
  [DELIVERY_STATUS_INACTIVE]: 'INACTIVE',
};
export const DELIVERY_STATUS_CHOICES = [
  { id: MAPPING_REQUEST_STATUS_APPROVED, name: "Approved" },
  { id: MAPPING_REQUEST_STATUS_UNLINKED_FOODY, name: "Unlink Foody"},
];

export const OCHA_MENU_OBJECT_LIST = [
{ id: 1, name: "Category" },
{ id: 2, name: "Item" },
{ id: 3, name: "Modifier set" },
{ id: 4, name: "Modifier option" },
{ id: 5, name: "Item mod set" },
];

export const OCHA_MENU_OBJECT_LIST_CHOICE = [
  { id: 0, name: "All" },
  ...OCHA_MENU_OBJECT_LIST
];

export const getSwitchFunctionDetailUrl = (feature) => {
  const encoded_feature = encodeURIComponent(feature);
  return `${baseUrlFunctionSwitch}/${encoded_feature}`;
};

export const getFrontEndUrlByFeature = (baseUrl, feature) => {
  const encoded_feature = encodeURIComponent(feature);
  return baseUrl.replace(':feature', encoded_feature);
};


export const CLIENT_TYPE_NA = 0;
export const CLIENT_WEB = 512;
export const CLIENT_WEB_INTERNAL = 513;
export const CLIENT_IOS = 4096;
export const CLIENT_IOS_INTERNAL = 4097;
export const CLIENT_ANDROID_GOOGLE_PLAY = 4352;
export const CLIENT_ANDROID_GOOGLE_PLAY_INTERNAL = 4353;
export const CLIENT_ANDROID_SUNMI = 4354;
export const CLIENT_ANDROID_SUNMI_INTERNAL = 4355;
export const CLIENT_PARTNER_OTGS_CLIENT = 2147418113;

export const CLIENT_TYPE_LIST = [
  { id: CLIENT_TYPE_NA, name: "NA" },
  { id: CLIENT_WEB, name: "Web" },
  { id: CLIENT_WEB_INTERNAL, name: "Web Internal" },
  { id: CLIENT_IOS, name: "IOS" },
  { id: CLIENT_IOS_INTERNAL, name: "IOS Internal" },
  { id: CLIENT_ANDROID_GOOGLE_PLAY, name: "Android Google Play" },
  { id: CLIENT_ANDROID_GOOGLE_PLAY_INTERNAL, name: "Android Google Play Internal" },
  { id: CLIENT_ANDROID_SUNMI, name: "Android Sunmi" },
  { id: CLIENT_ANDROID_SUNMI_INTERNAL, name: "Android Sunmi Internal" },
  { id: CLIENT_PARTNER_OTGS_CLIENT, name: "Partner OTGS Client" },
];

export const APP_TYPE_NA = 0;
export const APP_OCHA_APP = 1;
export const APP_OCHA_MANAGER = 2;
export const APP_OCHA_STAFF = 3;

export const APP_TYPE_LIST = [
  { id: APP_TYPE_NA, name: "NA" },
  { id: APP_OCHA_APP, name: "Ocha App" },
  { id: APP_OCHA_MANAGER, name: "Ocha Manager" },
  { id: APP_OCHA_STAFF, name: "Ocha Staff" },
];

export const CLIENT_NA = 0;
export const CLIENT_SUPPORTED = 1;
export const CLIENT_DROPPING = 2;
export const CLIENT_UNSUPPORTED = 3;
export const CLIENT_UPDATED = 4;

export const CLIENT_RELEASE_INFO_MESSAGE_TYPE_NA = 0;
export const CLIENT_RELEASE_INFO_MESSAGE_TYPE_CHANGELOG = 1;
export const CLIENT_RELEASE_INFO_MESSAGE_TYPE_DROPPING = 2;
export const CLIENT_RELEASE_INFO_MESSAGE_TYPE_UNSUPPORTED = 3;

export function convertVersionNumber(version_number) {
  let temp = parseInt(version_number, 10);
  const major = Math.floor(temp / 10000);
  temp = temp - (major * 10000);
  const minor = Math.floor(temp / 100);
  temp = temp - (minor * 100);
  return `${major}.${minor}.${temp}`;
}

export function generateVersionNumber(version_number) {
  let numbers = version_number.split('.');
  const major = parseInt(numbers[0], 10) * 10000;
  const minor = parseInt(numbers[1], 10) * 100;
  const patch = parseInt(numbers[2], 10);
  return major + minor + patch;
}

export function convertTimeToDate(time) {
  if (!time) {
    return '-';
  }

  const date = new Date(time);
  return date.toLocaleDateString('en-GB', {
      day:'numeric',
      month : 'short',
      year: '2-digit',
  });
}

function getIdNameMap(arr) {
  return arr.reduce((prev, item)=>{
    return {
      ...prev,
      [item.id]: item.name
    }
  }, {});
}


export const DualScreenAdTypeChoices = [
  {id: 1, name: 'Standby Ad'},
  {id: 2, name: 'Bill Page Ad'}
];

export const DualScreenAdStatusDisable = 0;
export const DualScreenAdStatusEnable = 1;

export const DualScreenAdStatusChoices = [
  { id: DualScreenAdStatusDisable, name: 'Disable'},
  { id: DualScreenAdStatusEnable, name: 'Enable'},
];

export const DualScreenAdTargetTypeAll= 1;
export const DualScreenAdTargetTypeSelect = 2;
export const DualScreenAdTargetUsersChoices = [
  { id: DualScreenAdTargetTypeAll, name: 'All'},
  { id: DualScreenAdTargetTypeSelect, name: 'Selected User'},
];


export const DualScreenAdTypeMap = getIdNameMap(DualScreenAdTypeChoices);

export const DualScreenAdStatusMap = getIdNameMap(DualScreenAdStatusChoices);

export const DualScreenAdTargetUsersMap = getIdNameMap(DualScreenAdTargetUsersChoices);

export const MaxMerchantIdLength = 128;


// WEBPACK FOOTER //
// ./src/routes/advancedFunction/utils.js